import React from 'react'
import ChargebackTemplate from '../ChargebacksTemplate/ChargebackTemplate'

const AwaitingResponse = () => {
  return (
    <div>
      <ChargebackTemplate title='Awaiting Response' status="Awaiting"/>
    </div>
  )
}

export default AwaitingResponse
